import { DataSignal } from 's-js';

import { CachedModelLoader } from 'lib/CachedModelLoader';
import { TZUtils } from 'lib/tzutils';

import { OperationsForecastResponse, OperationsForecastResponseOptions } from 'data/models/OperationsForecast';

import { Tab } from './model';

export type OperationsForecastLoader = CachedModelLoader<OperationsForecastResponse, OperationsForecastResponseOptions>;

export interface OperationsForecastParams {
    id : number
}

export let OperationsForecast = (params : OperationsForecastParams, currentTab : DataSignal<Tab>, tzutils : TZUtils, loader : OperationsForecastLoader) => {
    const { model: Model } = loader({ OrganizationId : params.id, Date : tzutils.today().toJSON() });
    return { Model, CurrentTab: currentTab };
};
export type OperationsForecast = ReturnType<typeof OperationsForecast>;


// WEBPACK FOOTER //
// ./apps/portcall/berthmgrdashboard/operationsforecast.ts